import { InquiryEndpoints } from "../api/admin/inquiry.endpoints";
import APIrequest from "../lib/axios"

export const InquiryService = {
    async createInquiry(data) {
        try {
            const payload = {
                ...InquiryEndpoints.createInquiry,
                bodyData: data
            }
            const response = await APIrequest(payload);
            return response.data
        } catch (error) {
            console.log(error)
        }
    },
    async getAllInquiries() {
        try {
            const payload = {
                ...InquiryEndpoints.getAllInquiries,
            }
            const response = await APIrequest(payload);
            return response.data
        } catch (error) {
            console.log(error)
        }
    },
    async getInquiry(id) {
        try {
            const payload = {
                ...InquiryEndpoints.getInquiry(id),
            }
            const response = await APIrequest(payload);
            return response.data
        } catch (error) {
            console.log(error)
        }
    },
    async updateInquiry(id, data) {
        try {
            const payload = {
                ...InquiryEndpoints.updateInquiry,
                params: { id },
                bodyData: data
            }
            const response = await APIrequest(payload);
            return response.data
        } catch (error) {
            console.log(error)
        }
    },
    async deleteInquiry(id) {
        try {
            const payload = {
                ...InquiryEndpoints.deleteInquiry,
                params: { id }
            }
            const response = await APIrequest(payload);
            return response.data
        } catch (error) {
            console.log(error)
        }
    },
}